import { useEffect } from "react";


// Created for PR_11773
const AccessiBeLoader = () => {
  useEffect(() => {
    // Load script only if not already present
    if (!document.getElementById("accessibe-script")) {
      const script = document.createElement("script");
      script.id = "accessibe-script";
      script.src = "https://acsbapp.com/apps/app/dist/js/app.js";
      script.async = true;
      script.onload = () => {
        console.log(" AccessiBe loaded");
        if (window.acsbJS) {
          window.acsbJS.init();
        }
      };
      document.body.appendChild(script); // Append to body to avoid blocking <head>
    }
  }, []);

  return null;
};

export default AccessiBeLoader;
